$(document).ready(function() {

  let $selectType = $('#boutique_filter select#type'),
      $selectGender = $('#boutique_filter select#gender'),
      $inputAge = $('#boutique_filter input[name="age"]'),
      $submit = $('#boutique_filter .reset');

  $submit.on('click', function() {
    filterProducts();
  });

  function filterProducts() {
    let type = $selectType.val(),
        gender = $selectGender.val(),
        age = $inputAge.val();

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'filter-products',
        'type': type,
        'gender': gender,
        'age': age
      }
    }).done( function (response) {
      $('#products_result .result span').html(response.count);
      $('#products_result .watches-list').html(response.output);
    });
  }

  $(document).on("click", 'button.add_cart', function(e) {
    e.preventDefault();

    let $button = $(this),
        product_id = $(this).val(),
        quantity = $(this).parent().find('input.qty').val();

    $button.prop('disabled', true);
    $button.append('<i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'add-to-cart',
        'product_id': product_id,
        'quantity': quantity
      }
    }).done( function (response) {
      $button.prop('disabled', false);
      $button.find('i.fa-spin').remove();

      updateMiniCart(response.cart.fragments.html);

      dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': 'EUR',
          'add': {
            'products': [{
              'name': response.product_name,
              'id': product_id,
              'price': response.product_price,
              'brand': 'Twistiti',
              'category': response.product_cat,
              'variant': '',
              'quantity': quantity
            }]
          }
        }
      });
    });
  });

  $(document).on('click', 'a.custom_remove_from_cart_button', function (e) {
    e.preventDefault();

    let $productElement = $(this).parent(),
        product_id = $(this).data('product_id'),
        hash = $(this).data('cart_item_key'),
        quantity = $(this).data('quantity');

    $productElement.prepend('<div class="loading-overlay"><i class="fas fa-2x fa-spinner fa-spin"></i></div>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'remove-from-cart',
        'product_id': product_id,
        'hash': hash,
        'quantity': quantity
      }
    }).done( function (response) {
      updateMiniCart(response.fragments.html);
    });
  });

  function updateMiniCart(fragments) {
    let $cartContainer = $('ul.cart_links'),
        $cartLinks = $cartContainer.find('.cart'),
        $overlay = $('.overlay_menu');

    if ($cartContainer.hasClass('cart_links_mobile')) {
      let $popup_trigger = $('.popup_trigger');
      $cartLinks.html('<a href="' + urls.cart + '">' + fragments + '</a>');
      if ($('.popup_mobile').length > 0) {
        if ($(window).width() > 900) {
          $popup_trigger.parents().find('#page_boutique').find('.popup[data-popup="' + $popup_trigger.attr('data-popup-target') + '"]').removeClass('is-visible');
        } else {
          $popup_trigger.parents().find('#page_boutique').find('.popup[data-popup="' + $popup_trigger.attr('data-popup-target') + '"]').addClass('is-visible');
        }
      }
    } else {
      $cartLinks.html(fragments);
      $cartLinks.find('.cart_box').prepend('<div class="added"><span><i class="fas fa-check"></i></span> ' + trans.add_to_cart + '</div>');

      if (!$cartLinks.hasClass('open')) {
        $cartLinks.addClass('open');
      }

      if (!$overlay.hasClass('open')) {
        $overlay.addClass('open');
      }
    }
  }

  $("button#load_more").on('click', function(e) {
    e.preventDefault();

    const $button = $(this),
        type = $button.data('type'),
        dial = $button.data('dial'),
        term = $button.data('term'),
        to_load = $button.data('to_load'),
        template = $button.data('template'),
        page = $button.data('page');

    $button.prop('disabled', true);
    $button.append('<i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'load-more',
        'type': type,
        'dial': dial,
        'term': term,
        'page': page,
        'to_load': to_load,
        'template': template
      }
    }).done( function (response) {
      $button.parent().prev().append(response.products);
      $button.data('page', response.page);
      $button.prop('disabled', false);
      $button.find('i').remove();
    });
  });

  let $formSingleAddToCart = $('form#single-add-to-cart'),
      $formCartContainer = $('.woocommerce-cart-form-container');

  if ($formCartContainer.length > 0) {

    $formCartContainer.on('click', '.input-number-decrement', function () {
      let $qtyInput = $(this).siblings('input.qty'),
          oldValue = $qtyInput.val(),
          newVal = parseInt(oldValue) - 1;

      if (newVal < 0) {
        newVal = 0;
      }

      $qtyInput.val(newVal);
    });

    $formCartContainer.on('click', '.input-number-increment', function () {
      let $qtyInput = $(this).siblings('input.qty'),
          oldValue = $qtyInput.val(),
          newVal = parseInt(oldValue) + 1;

      $qtyInput.val(newVal);
    });
  }

  if ($formSingleAddToCart.length > 0) {
    let $qtyInput = $('input.qty'),
        $decrementButton = $('.input-number-decrement'),
        $incrementButton = $('.input-number-increment');


    $decrementButton.click(function () {
      let oldValue = $qtyInput.val(),
        newVal = parseInt(oldValue) - 1;

      if (newVal < 1) {
        newVal = 1;
      }

      $qtyInput.val(newVal);
    });

    $incrementButton.click(function () {
      let oldValue = $qtyInput.val(),
        newVal = parseInt(oldValue) + 1;

      $qtyInput.val(newVal);
    });
  }

  if (vars.upsell_enabled === '1') {
    let $formAddExtraStrap = $('#add-extra-strap'),
      $button = $formAddExtraStrap.find('button[type="submit"]');

    $formAddExtraStrap.on('submit', function (e) {
      e.preventDefault();

      let product_id = $formAddExtraStrap.find('input#product_id').val(),
        linked_to = $formAddExtraStrap.find('input#linked_to').val();

      $button.prop('disabled', true);
      $button.append('<i class="fas fa-spinner fa-spin"></i>');

      $.ajax({
        url: urls.ajax,
        method: 'post',
        data: {
          'action': 'add-to-cart',
          'product_id': product_id,
          'linked_to': linked_to,
          'quantity': 1,
          'composed': true
        }
      }).done( function (response) {
        $button.prop('disabled', false);
        $button.find('i.fa-spin').remove();
        $('.popup_straps .popup-close').click();

        updateMiniCart(response.cart.fragments.html);

        dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'currencyCode': 'EUR',
            'add': {
              'products': [{
                'name': response.product_name,
                'id': product_id,
                'price': response.product_price,
                'brand': 'Twistiti',
                'category': response.product_cat,
                'variant': '',
                'quantity': 1
              }]
            }
          }
        });
      });
    });
  }

  if (vars.adult_clock_enabled === '1') {
    let $formAddExtraMom = $('#add-extra-mom'),
        $button = $formAddExtraMom.find('button[type="submit"]');

    $formAddExtraMom.on('submit', function (e) {
      e.preventDefault();

      let product_id = $formAddExtraMom.find('input#product_id').val(),
          linked_to = $formAddExtraMom.find('input#linked_to').val();

      $button.prop('disabled', true);
      $button.append('<i class="fas fa-spinner fa-spin"></i>');

      $.ajax({
        url: urls.ajax,
        method: 'post',
        data: {
          'action': 'add-to-cart',
          'product_id': product_id,
          'linked_to': linked_to,
          'quantity': 1,
          'composed': true
        }
      }).done( function (response) {
        $button.prop('disabled', false);
        $button.find('i.fa-spin').remove();
        $('.popup_straps .popup-close').click();

        updateMiniCart(response.cart.fragments.html);

        dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'currencyCode': 'EUR',
            'add': {
              'products': [{
                'name': response.product_name,
                'id': product_id,
                'price': response.product_price,
                'brand': 'Twistiti',
                'category': response.product_cat,
                'variant': '',
                'quantity': 1
              }]
            }
          }
        });
      });
    });
  }

});
